import usePendingState from '../Hooks/usePendingState';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useNotification } from '../Contexts/NotificationContext';
import Loading from './Loading';

function FormLogin() {
    const { setNotification } = useNotification();
    const [formLoading, setFormLoading, formPendingRef] = usePendingState();
    const [userData, setUserData] = useState({
        password: '',
        password_confirmation: '',
    });

    const [userErrorData, setUserErrorData] = useState({
        password: [],
        password_confirmation: [],
    });

    const navigate = useNavigate();
    const { token } = useParams();
    const baseUrl = process.env.REACT_APP_API_URL;

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setUserData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (formPendingRef.current) return;
        setFormLoading(true);
        try {
            const response = await fetch(`${baseUrl}/senha/atualizar/${token}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(userData),
            });
            if (response.ok) {
                const data = await response.json();

                setNotification({
                    type: 'success',
                    message: data.message,
                    show: true,
                });

                navigate('/login');
            } else {
                if (response.status === 422) {
                    const errors = await response.json();

                    setUserErrorData(errors);
                } else {
                    throw new Error('Erro ao atualizar a senha.');
                }
            }
        } catch (error) {
            setNotification({
                type: 'error',
                message: error.message,
                show: true,
            });
        } finally {
            setFormLoading(false);
        }
    };

    return (
        <>
            <form onSubmit={handleSubmit}>
                <div className="mb-4">
                    <label className="mb-2 ml-2 block text-left text-white">Nova Senha</label>
                    <input
                        type="password"
                        name="password"
                        value={userData.password}
                        onClick={() => setUserErrorData((prevData) => ({ ...prevData, password: [] }))}
                        onChange={handleChange}
                        className="w-full rounded-lg border border-stroke py-3 lg:py-4 pl-6 pr-10 outline-none focus:border-secondary focus-visible:shadow-none"
                    />
                    {userErrorData.password && userErrorData.password[0] && (
                        <span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">
                            {userErrorData.password[0]}{' '}
                            <span
                                onClick={() => setUserErrorData((prevData) => ({ ...prevData, password: [] }))}
                                className="rotate-45 -my-2 p-2 cursor-pointer"
                            >
                                +
                            </span>
                        </span>
                    )}
                </div>

                <div className="mb-10">
                    <label className="mb-2 ml-2 block text-left text-white">Confirme a Senha</label>
                    <input
                        type="password"
                        name="password_confirmation"
                        value={userData.password_confirmation}
                        onClick={() => setUserErrorData((prevData) => ({ ...prevData, password_confirmation: [] }))}
                        onChange={handleChange}
                        className="w-full rounded-lg border border-stroke py-3 lg:py-4 pl-6 pr-10 outline-none focus:border-secondary focus-visible:shadow-none"
                    />
                    {userErrorData.password_confirmation && userErrorData.password_confirmation[0] && (
                        <span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">
                            {userErrorData.password_confirmation[0]}{' '}
                            <span
                                onClick={() => setUserErrorData((prevData) => ({ ...prevData, password_confirmation: [] }))}
                                className="rotate-45 -my-2 p-2 cursor-pointer"
                            >
                                +
                            </span>
                        </span>
                    )}
                </div>

                <button
                    type="submit"
                    disabled={formLoading}
                    aria-busy={formLoading}
                    className="w-full bg-secondary text-white py-2 px-4 rounded-md hover:bg-opacity-80 disabled:bg-opacity-80 disabled:cursor-not-allowed"
                >
                    {!formLoading ? 'Enviar' : <Loading />}
                </button>
            </form>
        </>
    );
}

export default FormLogin;
